export default class LeaseholdClauses {
    id: number;
    leasePoolingProvisions: number;
    oilAcres: number;
    gasAcres: number;
    depthPugh: boolean;
    pugh: boolean;
    depthExclusion: boolean;
    continuingDevelopment: boolean;
    shutIn: boolean;
    surfaceRestriction: boolean;
    favoredNation: boolean;
    nonDrilling: boolean;
    topLeaseLanguage: boolean;
    netProceedsLease: boolean;
    costFreeRoyalty: boolean;
    consentToAssign: boolean;
    noticeOfAssign: boolean;
    poolingProvision: boolean;
    other: boolean;

    depthPughDescription: string;
    pughDescription: string;
    depthExclusionDescription: string;
    continuingDevelopmentDescription: string;
    shutInDescription: string;
    surfaceRestrictionDescription: string;
    favoredNationDescription: string;
    nonDrillingDescription: string;
    topLeaseLanguageDescription: string;
    netProceedsLeaseDescription: string;
    costFreeRoyaltyDescription: string;
    consentToAssignDescription: string;
    noticeOfAssignDescription: string;
    poolingProvisionDescription: string;
    otherDescription: string;
}



// WEBPACK FOOTER //
// ./src/models/leasehold/LeaseholdClauses.ts